<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-chat-left-text me-2"></i> Question Comments</h1>
  <p class="page-subtitle">View and manage question comments by user. Filter by course, subject, and subscribed user.</p>

  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="form-label">Course</label>
          <select class="form-select" [(ngModel)]="selectedCourseId" (ngModelChange)="onCourseChange($event)" [disabled]="isLoadingCourses">
            <option [ngValue]="null">Select course…</option>
            @for (course of courses; track course.id) {
              <option [ngValue]="course.id">{{ course.name }}</option>
            }
          </select>
          @if (isLoadingCourses) {
            <small class="text-muted">Loading courses…</small>
          }
        </div>
        <div class="col-md-4">
          <label class="form-label">Subject</label>
          <select class="form-select" [(ngModel)]="selectedSubjectId" (ngModelChange)="onSubjectChange()" [disabled]="isLoadingSubjects || !selectedCourseId">
            <option [ngValue]="null">All</option>
            @for (subject of subjects; track subject.id) {
              <option [ngValue]="subject.id">{{ subject.name }}</option>
            }
          </select>
          @if (isLoadingSubjects) {
            <small class="text-muted">Loading subjects…</small>
          }
        </div>
        <div class="col-md-4">
          <label class="form-label">User (subscribed to course)</label>
          <select class="form-select" [(ngModel)]="selectedUserId" (ngModelChange)="onUserChange()" [disabled]="isLoadingUsers || !selectedCourseId">
            <option [ngValue]="null">All</option>
            @for (u of subscribedUsers; track u.id) {
              <option [ngValue]="u.id">{{ u.username }}</option>
            }
          </select>
          @if (isLoadingUsers) {
            <small class="text-muted">Loading users…</small>
          }
        </div>
      </div>
      <div class="mb-3">
        <button type="button" class="btn btn-primary" [disabled]="!canSearch" (click)="onSearch()">
          Search
        </button>
      </div>
    </div>
  </div>

  <div class="card mt-4">
    <div class="card-body">
      <h3 class="h5 mb-3">Results @if (hasSearched) { <span class="badge bg-secondary">{{ results.length }}</span> }</h3>
      @if (!hasSearched && !isSearching) {
        <div class="alert alert-info">Select course and optionally subject and user (or All), then click Search.</div>
      }
      @if (results.length === 0 && hasSearched && !isSearching) {
        <div class="alert alert-info">No comments found for the selected filters.</div>
      }
      @if (isSearching) {
        <div class="text-center py-4">
          <span class="spinner-border spinner-border-sm me-2"></span>
          <span>Searching…</span>
        </div>
      }
      @if (results.length > 0 && !isSearching) {
        <div class="list-group">
          @for (item of paginatedResults; track item.questionId) {
            <div class="list-group-item list-group-item-action" role="button" tabindex="0"
                 (click)="openDetail(item.questionId)" style="cursor: pointer;">
              <div class="d-flex w-100 justify-content-between mb-2">
                <h6 class="mb-1">Question #{{ item.questionId }}</h6>
                <small class="text-muted">{{ item.subjectName }}</small>
              </div>
              <p class="mb-1 text-truncate" [title]="resultDisplayHtmlById[item.questionId]">
                {{ getQuestionDisplay(item.questionId) }}
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <p class="mb-0 text-muted small" [title]="resultCommentHtmlById[item.questionId]"
                   style="max-width: 70%; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                  {{ getCommentDisplay(item.questionId) }}
                </p>
                @if (item.commentCount > 1) {
                  <small class="text-muted ms-2">{{ item.commentCount }} comments</small>
                }
              </div>
            </div>
          }
        </div>

        @if (results.length > itemsPerPage) {
        <nav aria-label="Results pagination" class="mt-4">
          <ul class="pagination justify-content-center">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" href="javascript:void(0)" (click)="previousPage()">&laquo;</a>
            </li>
            @for (page of pageNumbers; track page) {
              <li class="page-item" [class.active]="page === currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">{{ page }}</a>
              </li>
            }
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" href="javascript:void(0)" (click)="nextPage()">&raquo;</a>
            </li>
          </ul>
          <div class="text-center text-muted small mt-2">
            Showing {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, results.length) }} of {{ results.length }} results
          </div>
        </nav>
        }
      }
    </div>
  </div>
</div>

<app-question-detail-modal
  [open]="detailOpen"
  [questionId]="detailQuestionId"
  [questionHtml]="detailQuestionHtml"
  [answersHtml]="detailAnswersHtml"
  [correctAnswer]="detailCorrectAnswer"
  [initialTab]="'comments'"
  (closed)="closeDetail()">
</app-question-detail-modal>
